import { get, post } from "src/services/api";
import { ADMIN_DASHBOARD_SETTINGS_ENDPOINT, DASHBOARD_SETTINGS_ENDPOINT } from "src/components/admin/Settings/useSettings";
import useAppStore from "src/stores/appStore";

export const fetchDashboardSettings = async (isAdminPanel) => {
  const url = isAdminPanel ? ADMIN_DASHBOARD_SETTINGS_ENDPOINT : DASHBOARD_SETTINGS_ENDPOINT;
  const dashboardSettings = await get({ endpoint: url });
  useAppStore.getState().setDashboardSettings(dashboardSettings);
  return dashboardSettings;
};

export const addPhoneNumber = async (params, data) => await post({
  endpoint: `/account/${params.accountId}/assistant/${params.assistantId}/settings/phone-numbers`,
  data
});

export const getPhoneNumbersMetadata = async (params, data) => await get({
  endpoint: `/account/${params.accountId}/assistant/${params.assistantId}/settings/twilio-urls`,
  params: data
});

export const checkIfPhoneNumberIsUsed = async (params) => await get({
  endpoint: `/accounts/${params.accountId}/assistants/${params.assistantId}/settings/phone-number-used`,
  params: { phoneNumber: params.phoneNumber }
});
